<template>
<div class="chapter">
<div class="inner_page">
<p class="fmtitle"><a id="page_xvii">ABBREVIATIONS</a></p><a id="page_xvii">
<table cellpadding="0" cellspacing="0" width="100%">
<colgroup><col width="20%"/>
<col width="80%"/>
</colgroup><tbody><tr>
<td valign="top"><p class="tab1">Add</p></td>
<td valign="top"><p class="tab1">Additional Manuscripts</p></td>
</tr>
<tr>
<td valign="top"><p class="tab1">AE</p></td>
<td valign="top"><p class="tab1">Paris, Ministère des Relations Extérieures</p></td>
</tr>
<tr>
<td valign="top"><p class="tab1">Ang</p></td>
<td valign="top"><p class="tab1">Angleterre</p></td>
</tr>
<tr>
<td valign="top"><p class="tab1">BB</p></td>
<td valign="top"><p class="tab1">Bland Burges papers</p></td>
</tr>
<tr>
<td valign="top"><p class="tab1"><i>BJECS</i></p></td>
<td valign="top"><p class="tab1"><i>British Journal for Eighteenth-Century Studies</i></p></td>
</tr>
<tr>
<td valign="top"><p class="tab1">BL</p></td>
<td valign="top"><p class="tab1">London, British Library, Department of Manuscripts</p></td>
</tr>
<tr>
<td valign="top"><p class="tab1">Bod.</p></td>
<td valign="top"><p class="tab1">Oxford, Bodleian Library</p></td>
</tr>
<tr>
<td valign="top"><p class="tab1">Cobbett</p></td>
<td valign="top"><p class="tab1">W. Cobbett, ed., <i>Cobbett’s Parliamentary History of England … 1066 to … 1803</i> (36 vols., London, 1806–20)</p></td>
</tr>
<tr>
<td valign="top"><p class="tab1">CP</p></td>
<td valign="top"><p class="tab1">Correspondance Politique</p></td>
</tr>
<tr>
<td valign="top"><p class="tab1">CRO</p></td>
<td valign="top"><p class="tab1">County Record Office</p></td>
</tr>
<tr>
<td valign="top"><p class="tab1">Eg</p></td>
<td valign="top"><p class="tab1">Egerton Manuscripts</p></td>
</tr>
<tr>
<td valign="top"><p class="tab1">Farmington</p></td>
<td valign="top"><p class="tab1">Farmington, Connecticut, Lewis Walpole Library</p></td>
</tr>
<tr>
<td valign="top"><p class="tab1">FO</p></td>
<td valign="top"><p class="tab1">Foreign Office papers</p></td>
</tr>
<tr>
<td valign="top"><p class="tab1">NA</p></td>
<td valign="top"><p class="tab1">London, National Archives</p></td>
</tr>
<tr>
<td valign="top"><p class="tab1">SP</p></td>
<td valign="top"><p class="tab1">State Papers</p></td>
</tr>
</tbody></table>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08_Abbreviations.vue?26a42c42